import { render, staticRenderFns } from "./ServiceGroupNew.vue?vue&type=template&id=0f04cf64&scoped=true&"
import script from "./ServiceGroupNew.vue?vue&type=script&lang=js&"
export * from "./ServiceGroupNew.vue?vue&type=script&lang=js&"
import style0 from "./ServiceGroupNew.vue?vue&type=style&index=0&id=0f04cf64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f04cf64",
  null
  
)

export default component.exports